export default {
  kbArticleUpdatedOn: 'Updated on {{date}}',
};
